import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

const PrivacyPolicyMarkdown: React.FC = () => {
  const [markdown, setMarkdown] = useState("");

  useEffect(() => {
    const fetchMarkdown = async () => {
      try {
        const response = await fetch("/privacy-policy/pl.md");
        const text = await response.text();
        setMarkdown(text);
      } catch (error) {
        console.error("Error loading privacy policy markdown:", error);
      }
    };

    fetchMarkdown();
  }, []);

  return (
        <div className="card-container center">
      <ReactMarkdown>{markdown}</ReactMarkdown>
    </div>
  );
};

export default PrivacyPolicyMarkdown;
